import { render, staticRenderFns } from "./poissaolot-display.vue?vue&type=template&id=621d8254&scoped=true&"
import script from "./poissaolot-display.vue?vue&type=script&lang=ts&"
export * from "./poissaolot-display.vue?vue&type=script&lang=ts&"
import style0 from "./poissaolot-display.vue?vue&type=style&index=0&id=621d8254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d8254",
  null
  
)

export default component.exports